import { useService } from 'react-reservice';

import { resetPasswordFormService } from './service';

export * from './service';

export const useResetPasswordFormService = () => {
  return useService(resetPasswordFormService, (state) => state);
};

export { resetPasswordFormService };
